import RequestParams_vue_vue_type_script_setup_true_lang_default from "./RequestParams.vue.script.js";
//#region src/v2/blocks/request-block/components/RequestParams.vue
var RequestParams_default = RequestParams_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { RequestParams_default as default };

//# sourceMappingURL=RequestParams.vue.js.map